import React from 'react'
import _ from 'lodash'

function getImageRef(imageRef) {
  return _.get(imageRef, 'current') ? _.get(imageRef, 'current') : imageRef
}

export function useNaturalSizeImage(imageRef) {
  const [width, setWidth] = React.useState(0)
  const [height, setHeight] = React.useState(0)

  React.useEffect(() => {
    setImageSize(getImageRef(imageRef))
  }, [imageRef])

  function setImageSize(_imageRef) {
    _imageRef.onload = function() {
      setWidth(_.get(_imageRef, 'naturalWidth'))
      setHeight(_.get(_imageRef, 'naturalHeight'))
    }
  }

  return {
    width,
    height,
  }
}



// WEBPACK FOOTER //
// ./src/modules/image/imageUtil.js